export default "__VITE_ASSET__BNJSrCDV__"